define('components/course/models/course',[
    'components/course/collections/levels',
    'components/course/models/base'
], function (Levels, Base) {
    "use strict";

    return Base.extend({
        "childrenAttribute": "levels",

        "url": "./course.cfc",

        "complexRelations": function () {
            var complexRelations = Base.prototype.complexRelations.call(this);

            complexRelations = _.union(complexRelations, [
                {
                    "attr": "levels",
                    "Class": Levels
                }
            ]);

            return complexRelations;
        },

        "defaults": function () {
            return _.extend(Base.prototype.defaults.call(this), {
                "title": null,
                "levels": null
            });
        },

        "getRequestOptions": function (requestType, opts) {
            if (requestType === 'create') {
                // Because the API does not have a `create` method
                // and FE is supposed to use `update` instead.
                requestType = 'update';
            }

            return Base.prototype.getRequestOptions.call(this, requestType, opts);
        }
    });
});

